import { toValue } from 'vue'
import type { Locale } from 'vue-i18n'

export function useNetPriceLabel() {
  const { feature, netPriceSuffix } = useCountryConfig()
  const locale = toValue(useNuxtApp().$i18n.locale) as Locale
  const label = feature.displayNetPriceSuffix === true
    ? (netPriceSuffix?.[locale] ?? '')
    : ''

  function withSuffix(price: string | number | null | undefined): string {
    if (price == null || price === '')
      return ''
    // NBSP keeps "€ HT" on one line in narrow product-tile columns.
    return label ? `${price}\u00A0${label}` : String(price)
  }

  return {
    withSuffix,
    netPriceClass: label ? 'net-price' : undefined,
  }
}
